import { handleSessionOut } from "../Helpers/Helpers";
import { getToken } from "./tokenStore";

const NIMBLE_AUTH_API = import.meta.env.VITE_NIMBLE_AUTH_API;
const REPORT_CONFIG_API = import.meta.env.VITE_NIMBLE_REPORT_CONFIG;
const DASHBOARD_API = import.meta.env.VITE_NIMBLE_DASHBOARD_API;
const NIMBLE_API = import.meta.env.VITE_NIMBLE_CORE_API;


const apiRequest = async (url, options = {}) => {
    const token = getToken();

    const res = await fetch(url, {
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
            ...options.headers,
        },
    });

    if (res.status === 401) {
        handleSessionOut();
        throw new Error("Unauthorized");
    }

    const data = await res.json();

    if (!res.ok) {
        throw new Error(data?.message || "API request failed");
    }

    return data;
};



export const login = () =>
    apiRequest(`${NIMBLE_AUTH_API}/OpenApiauth/Login`, {
        method: "POST",
        body: JSON.stringify({
            userName: "nabhiuddin.shaik@nimbleaccounting.com",
            password: "0ILX5U",
            url: "qa2",
        }),
    });

export const exchangeOAuth = async (authID) => {
    const data = await apiRequest(
        `${NIMBLE_AUTH_API}/OpenApiauth/ExchangeOAuth`,
        {
            method: "POST",
            body: JSON.stringify({ token: authID }),
        }
    );
    return data.token;
};

export const getPrevileges = async (menuId) => {
    const data = await apiRequest(
        `${NIMBLE_API}/Previlages`,
        {
            method: "POST",
            body: JSON.stringify({
                RoleID: "",
                UserID: "",
                MenuIds: menuId
            }),
        }
    );

    return data?.Details[0] || {};
};


export const getISConfiguration = (menuID) =>
    apiRequest(`${REPORT_CONFIG_API}/GetISConfiguration?MenuId=${menuID}`);



export const getPCList = async (CorpID) => {
    // const data = await apiRequest(`${NIMBLE_API}/pcs?CorpID=${CorpID}`);
    const data = await apiRequest(`${REPORT_CONFIG_API}/BudgetConfig/pcs?CorpID=${CorpID}`);
    // let pcList = data?.ListInfo || data?.listInfo
    let pcList = (data?.ListInfo || data?.listInfo || []).map(item => ({
        SortOrder: item.sortOrder ?? item.SortOrder,
        CorporationID: item.corporationID ?? item.CorporationID,
        ID: item.id ?? item.ID,
        Name: item.name ?? item.Name,
        Type: item.type ?? item.Type,
        TypeName: item.typeName ?? item.TypeName,
        BrandName: item.brandName ?? item.BrandName,
        PaymentMethodType: item.paymentMethodType ?? item.PaymentMethodType,
        PurposeAccountID: item.purposeAccountID ?? item.PurposeAccountID,
        PurposeAccountName: item.purposeAccountName ?? item.PurposeAccountName,
        CreditDays: item.creditDays ?? item.CreditDays,
        Status: item.status ?? item.Status
    }));
    if (pcList.length > 0) {
        // const addUnclassified = { ID: "000000000000000000000000000000000001", Name: "Unclassified" }
        const addUnclassified = { ID: "000000000000000000000000000000000234", Name: "Unclassified" }
        pcList = [addUnclassified, ...pcList];
    };
    return pcList;
};


export const getIncomestatementJson = (payload) =>
    apiRequest(`${REPORT_CONFIG_API}/GetIncomestatementJson`, {
        method: "POST",
        body: JSON.stringify(payload),
    });


export const getIncomestatementInfo = (payload) =>
    apiRequest(`${DASHBOARD_API}/IncomestatementInfo`, {
        method: "POST",
        body: JSON.stringify(payload),
    });


export const setMemorizeOrReset = (url, payload) =>
    apiRequest(`${REPORT_CONFIG_API}/${url}`, {
        method: "POST",
        body: JSON.stringify(payload),
    });
export const incomestatementNetIncome = (payload) =>
    apiRequest(`${DASHBOARD_API}/IncomestatementNetIncome`, {
        method: "POST",
        body: JSON.stringify(payload),
    });

export const getCorporationDetails = (CorpID) =>
    apiRequest(`${NIMBLE_API}/CorporationDetails`, {
        method: "POST",
        body: JSON.stringify({ CorpID }),
    });



export const accountDetals = (corpId, accId) =>
    apiRequest(`${REPORT_CONFIG_API}/ReportConfig/AccountDetals?CorpId=${corpId}&AccountCode=${accId}`);




